/**
 * Constructor - creates a "Jump To..." HTML <ul> list for use as a w3s dropdown
 *  element: the HTML element that the dropdown items will go into
 *  list: an array of location ojects: {name: [minx, miny, maxx, maxy]}
 */

export default function (params) {
  var html = '';

  params.list.forEach(function(listItem) {
    for (let placeName in listItem) {
      html += `<a class="menu-item" target="${listItem[placeName]}" data-tool="jump">${placeName}</a>`;
    }
  });

  params.element.innerHTML = html;
  return true;
}
